import { forwardRef } from 'react';
import styled from '@emotion/styled';

import { borderRadius, color, spacing } from '../theme';
import { mediaDesktop } from '../theme/breakpoints';
import { FabProps } from './types';

const getIconSize = (props: FabProps) =>
  props.size === 'xs' ? '16px' : spacing.xs;

const FabWrapper = styled.button<FabProps>`
  padding: 0;
  border-radius: ${borderRadius.round};

  height: 30px;
  width: 30px;

  ${mediaDesktop} {
    height: 40px;
    width: 40px;
  }

  transition: background-color 300ms linear;

  :hover,
  :active {
    background-color: ${color('yellowMedium')};
  }

  svg {
    height: ${getIconSize};
    width: ${getIconSize};
  }
`;

const Content = styled.span`
  display: flex;
  align-items: center;
  height: 100%;
  margin: auto;
  width: ${getIconSize};
`;

export const Fab = forwardRef<HTMLButtonElement, FabProps>(
  (props: FabProps, ref) => {
    return (
      <FabWrapper {...props} ref={ref}>
        <Content aria-hidden="true" aria-label={props['aria-label']}>
          {props.children}
        </Content>
      </FabWrapper>
    );
  },
);
